import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WeatherForecastIconComponent } from './weather-forecast-icon/weather-forecast-icon.component';

@NgModule({
  declarations: [
    WeatherForecastIconComponent
  ],
  exports: [
    WeatherForecastIconComponent
  ],
  imports: [
    CommonModule
  ]
})
export class WeatherForecastModule { }
